import assign from 'lodash/assign';
import type { AllActionTypes } from '../constants';
import constants from '../constants';
import Filter from '../../models/Filter';
import type { PartialFilterType } from '../../models/Types';

export type State = Filter;

export type Actions = { type: AllActionTypes; payload: PartialFilterType };

const initialState: State = new Filter();

const filter = (state: State = initialState, action: Actions): State => {
  const { type, payload } = action;

  if (type === constants.UPDATE_FILTER) {
    return assign({}, state, payload);
  }
  return state;
};

export default filter;
